import React from 'react';
import { AlertInline, Select, Text } from '@eds-web/react';
import { useTranslation } from 'react-i18next';

import { useTaxDocumentSelection } from '../../hooks/useTaxDocumentSelection';
import { useSelector } from 'react-redux';
import { selectNoTaxProfile, selectTaxDocumentsLoading } from '../../selectors/tax.selector';
import { Loading } from '../common/Loading';
import { useTaxDocuments } from '../../hooks/useTaxDocuments';

interface TaxDocumentSelectionProps {
    // Props can be added here if needed
}

export const TaxDocumentSelection: React.FC<TaxDocumentSelectionProps> = () => {
    const { t } = useTranslation();
    const noTaxProfile = useSelector(selectNoTaxProfile);
    const loading = useSelector(selectTaxDocumentsLoading);
    const { selectOptions, selectedValue, handleYearChange, selectDefaultOptions } =
        useTaxDocumentSelection();
    const { fetchTaxDocumentsWithRetry, isRetrying, failedToLoad } = useTaxDocuments();
    const [clicked, setClicked] = React.useState(false);

    const handleClick = async () => {
        try {
            if (clicked) return;
            await fetchTaxDocumentsWithRetry();
            setClicked(true);
        } catch (error) {
            console.error('Failed to fetch tax documents:', error);
        }
    };

    const isLoading = loading || isRetrying;

    return (
        <>
            <Text variant={'headingSM'}>{t('epic.esport.profile.tax.form.title')}</Text>
            <Select
                placeholder={t('epic.esport.profile.placeholder.label.year')}
                style={{ width: '50%' }}
                value={selectedValue}
                options={isLoading || !clicked ? selectDefaultOptions : selectOptions}
                onChange={handleYearChange}
                onClick={handleClick}
                disabled={noTaxProfile || failedToLoad}
                label={t('epic.esport.profile.label.tax.year')}
                renderListItem={isLoading || !clicked ? () => <Loading /> : undefined}
            />
            {failedToLoad && (
                <AlertInline
                    status={'critical'}
                    message={t('errors.esport.prizes.generic.error')}
                />
            )}
        </>
    );
};
